import { sdkContextStatus } from "src/context/SDKContext"
import { useMutation, useQueryClient } from "react-query"
import { useRecoilState } from "recoil"
import axios from "src/shared/axios"
import {
  AuthedUser,
  authedUserAtom,
  AuthedUserUpdate
} from "src/recoil/atoms/authedUser"

export const QUERY_KEY = "requestx-user"

type Props = {
  onMutation?: () => void
  onMutationSuccess?: () => void
}

const useAuthedUser = ({ onMutation, onMutationSuccess }: Props = {}) => {
  const [authedUser, setAuthedUser] = useRecoilState(authedUserAtom)
  const queryClient = useQueryClient()

  async function getAuthedUser(): Promise<AuthedUser> {
    const { data } = await queryClient.fetchQuery({
      queryKey: [QUERY_KEY],
      queryFn: async () => {
        const meetingClient = await sdkContextStatus
        try {
          const response = await axios.get(
            meetingClient?.envConfig.USER_DETAILS,
            {
              withCredentials: true,
              validateStatus: () => true
            }
          )
          return response
        } catch (err) {
          console.error(err)
          throw err
        }
      }
    })
    setAuthedUser(data)
    return data
  }

  const mutation = useMutation({
    mutationFn: async (newAuthedUser: AuthedUserUpdate) => {
      const meetingClient = await sdkContextStatus
      return await axios
        .put(
          meetingClient?.envConfig.USER_DETAILS,
          { ...newAuthedUser },
          {
            withCredentials: true
          }
        )
        .then(onMutation)
    },
    onSuccess: () => {
      return queryClient
        .invalidateQueries({ queryKey: [QUERY_KEY] })
        .then(onMutationSuccess)
    }
  })

  return {
    authedUser,
    getAuthedUser,
    updateAuthedUser: mutation.mutate,
    updateAuthedUserAsync: mutation.mutateAsync,
    updating: mutation.isLoading
  } as const
}

export default useAuthedUser
